import { Deserializable } from '../protocols/deserializable';
import { AnnuityGuaranteePeriodType } from './annuity-guarantee-period-type';

export class MonthlyPensionAnnuityCalculation implements Deserializable {
  public guaranteePeriod!: AnnuityGuaranteePeriodType;
  public memberAmount!: number;

  public onDeserialize(): void {
    if (!!this.guaranteePeriod) {
      this.guaranteePeriod = window.injector.Deserialize.instanceOf(AnnuityGuaranteePeriodType, this.guaranteePeriod);
    }
  }
}
